export const Pagination = ({ pages, current_page, url_slug }: { pages: integer, current_page: integer, url_slug: string }) => {
  const has_previous = (current_page != 1);
  const has_next = (current_page < pages);

  if (pages == 0 || pages == 1) {
    return (<></>);
  }

  return (
    <>
      <div>
        <a className={ "mr-2 btn btn-outline" + (has_previous ? "" : " btn-disabled")} href={ url_slug.replace(':page', current_page - 1) }>Prev</a>
        <a className={ "btn btn-outline"+ (has_next ? "" : " btn-disabled") } href={ url_slug.replace(':page', current_page + 1) } >Next</a>
      </div>
    </>
  );
};
